import { URL } from '@/constants/urls'
import { tenantId } from '@/utils/tenantUrl'
import { fetchEventSource } from '@microsoft/fetch-event-source'

class SSEService {
  constructor() {
    this.controller = null
    this.eventFuns = new Map()
  }

  connectSSE(){
    // 已有有效连接时，不重复创建
    if(this.controller && !this.controller.signal.aborted) return

    this.controller = new AbortController()
    fetchEventSource(process.env.VUE_APP_API_BASE_URL + URL.SSE_CONNECT, {
      signal: this.controller.signal,
      headers: {
        'X-Tenant': tenantId
      },
      onmessage : (ev) =>  {
        const fun = this.eventFuns.get(ev.event)
        if(fun){
          fun(ev)
        }
      },
      onerror : (err) =>  {
        console.error('SSE error:', err)
        this._abortConnection()
        // 5秒后重连
        setTimeout(() => this.connectSSE(), 10000)
      },
      onclose: () => {
        this._abortConnection()
      }
    }).catch((err) =>{
      console.error('fetchEventSource failed:', err)
      this._abortConnection()
    })
  }

  closeSSE(){
    this._abortConnection()
  }

  on(eventName, callback){
    this.eventFuns.set(eventName, callback)
  }

  off(eventName){
    this.eventFuns.delete(eventName)
  }

  // 私有方法：终止当前连接并置空
  _abortConnection() {
    if (this.controller) {
      this.controller.abort();
      this.controller = null;
    }
  }
}
const sseService = new SSEService()
export default sseService